/* eslint-disable */
// @ts-nocheck
/**
 * @fileoverview gRPC-Web generated client stub for worklayer.internal.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: internal/job_admin.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js')

var internal_job_pb = require('../internal/job_pb.js')

var shared_types_decimal_pb = require('../shared/types/decimal_pb.js')

var internal_question_variable_value_pb = require('../internal/question_variable_value_pb.js')
const proto = {};
proto.worklayer = {};
proto.worklayer.internal = {};
proto.worklayer.internal.v1 = require('./job_admin_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.JobAdminServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.TransferJobToPoolRequest,
 *   !proto.worklayer.internal.v1.TransferJobToPoolResponse>}
 */
const methodDescriptor_JobAdminService_TransferJobToPool = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/TransferJobToPool',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.TransferJobToPoolRequest,
  proto.worklayer.internal.v1.TransferJobToPoolResponse,
  /**
   * @param {!proto.worklayer.internal.v1.TransferJobToPoolRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.TransferJobToPoolResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.TransferJobToPoolRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.TransferJobToPoolResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.TransferJobToPoolResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.transferJobToPool =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/TransferJobToPool',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_TransferJobToPool,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.TransferJobToPoolRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.TransferJobToPoolResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.transferJobToPool =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/TransferJobToPool',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_TransferJobToPool);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.TransferJobToClientRequest,
 *   !proto.worklayer.internal.v1.TransferJobToClientResponse>}
 */
const methodDescriptor_JobAdminService_TransferJobToClient = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/TransferJobToClient',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.TransferJobToClientRequest,
  proto.worklayer.internal.v1.TransferJobToClientResponse,
  /**
   * @param {!proto.worklayer.internal.v1.TransferJobToClientRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.TransferJobToClientResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.TransferJobToClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.TransferJobToClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.TransferJobToClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.transferJobToClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/TransferJobToClient',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_TransferJobToClient,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.TransferJobToClientRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.TransferJobToClientResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.transferJobToClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/TransferJobToClient',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_TransferJobToClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.TransferJobToProviderRequest,
 *   !proto.worklayer.internal.v1.TransferJobToProviderResponse>}
 */
const methodDescriptor_JobAdminService_TransferJobToProvider = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/TransferJobToProvider',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.TransferJobToProviderRequest,
  proto.worklayer.internal.v1.TransferJobToProviderResponse,
  /**
   * @param {!proto.worklayer.internal.v1.TransferJobToProviderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.TransferJobToProviderResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.TransferJobToProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.TransferJobToProviderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.TransferJobToProviderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.transferJobToProvider =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/TransferJobToProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_TransferJobToProvider,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.TransferJobToProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.TransferJobToProviderResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.transferJobToProvider =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/TransferJobToProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_TransferJobToProvider);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.TransferJobToClientTeamRequest,
 *   !proto.worklayer.internal.v1.TransferJobToClientTeamResponse>}
 */
const methodDescriptor_JobAdminService_TransferJobToClientTeam = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/TransferJobToClientTeam',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.TransferJobToClientTeamRequest,
  proto.worklayer.internal.v1.TransferJobToClientTeamResponse,
  /**
   * @param {!proto.worklayer.internal.v1.TransferJobToClientTeamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.TransferJobToClientTeamResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.TransferJobToClientTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.TransferJobToClientTeamResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.TransferJobToClientTeamResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.transferJobToClientTeam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/TransferJobToClientTeam',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_TransferJobToClientTeam,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.TransferJobToClientTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.TransferJobToClientTeamResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.transferJobToClientTeam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/TransferJobToClientTeam',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_TransferJobToClientTeam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RemoveClientTeamFromJobRequest,
 *   !proto.worklayer.internal.v1.RemoveClientTeamFromJobResponse>}
 */
const methodDescriptor_JobAdminService_RemoveClientTeamFromJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/RemoveClientTeamFromJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RemoveClientTeamFromJobRequest,
  proto.worklayer.internal.v1.RemoveClientTeamFromJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RemoveClientTeamFromJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RemoveClientTeamFromJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RemoveClientTeamFromJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RemoveClientTeamFromJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RemoveClientTeamFromJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.removeClientTeamFromJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RemoveClientTeamFromJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RemoveClientTeamFromJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RemoveClientTeamFromJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RemoveClientTeamFromJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.removeClientTeamFromJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RemoveClientTeamFromJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RemoveClientTeamFromJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RemoveJobCollaboratorRequest,
 *   !proto.worklayer.internal.v1.RemoveJobCollaboratorResponse>}
 */
const methodDescriptor_JobAdminService_RemoveJobCollaborator = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/RemoveJobCollaborator',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RemoveJobCollaboratorRequest,
  proto.worklayer.internal.v1.RemoveJobCollaboratorResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RemoveJobCollaboratorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RemoveJobCollaboratorResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RemoveJobCollaboratorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RemoveJobCollaboratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RemoveJobCollaboratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.removeJobCollaborator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RemoveJobCollaborator',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RemoveJobCollaborator,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RemoveJobCollaboratorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RemoveJobCollaboratorResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.removeJobCollaborator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RemoveJobCollaborator',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RemoveJobCollaborator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetJobPricingDetailsRequest,
 *   !proto.worklayer.internal.v1.GetJobPricingDetailsResponse>}
 */
const methodDescriptor_JobAdminService_GetJobPricingDetails = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/GetJobPricingDetails',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetJobPricingDetailsRequest,
  proto.worklayer.internal.v1.GetJobPricingDetailsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.GetJobPricingDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.GetJobPricingDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetJobPricingDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.GetJobPricingDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.GetJobPricingDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.getJobPricingDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/GetJobPricingDetails',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_GetJobPricingDetails,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetJobPricingDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.GetJobPricingDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.getJobPricingDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/GetJobPricingDetails',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_GetJobPricingDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.AddSupportingClientRequest,
 *   !proto.worklayer.internal.v1.AddSupportingClientResponse>}
 */
const methodDescriptor_JobAdminService_AddSupportingClient = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/AddSupportingClient',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.AddSupportingClientRequest,
  proto.worklayer.internal.v1.AddSupportingClientResponse,
  /**
   * @param {!proto.worklayer.internal.v1.AddSupportingClientRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.AddSupportingClientResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.AddSupportingClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.AddSupportingClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.AddSupportingClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.addSupportingClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/AddSupportingClient',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_AddSupportingClient,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.AddSupportingClientRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.AddSupportingClientResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.addSupportingClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/AddSupportingClient',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_AddSupportingClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.AddSupportingProviderRequest,
 *   !proto.worklayer.internal.v1.AddSupportingProviderResponse>}
 */
const methodDescriptor_JobAdminService_AddSupportingProvider = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/AddSupportingProvider',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.AddSupportingProviderRequest,
  proto.worklayer.internal.v1.AddSupportingProviderResponse,
  /**
   * @param {!proto.worklayer.internal.v1.AddSupportingProviderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.AddSupportingProviderResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.AddSupportingProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.AddSupportingProviderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.AddSupportingProviderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.addSupportingProvider =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/AddSupportingProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_AddSupportingProvider,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.AddSupportingProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.AddSupportingProviderResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.addSupportingProvider =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/AddSupportingProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_AddSupportingProvider);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.AddChampionProviderRequest,
 *   !proto.worklayer.internal.v1.AddChampionProviderResponse>}
 */
const methodDescriptor_JobAdminService_AddChampionProvider = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/AddChampionProvider',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.AddChampionProviderRequest,
  proto.worklayer.internal.v1.AddChampionProviderResponse,
  /**
   * @param {!proto.worklayer.internal.v1.AddChampionProviderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.AddChampionProviderResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.AddChampionProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.AddChampionProviderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.AddChampionProviderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.addChampionProvider =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/AddChampionProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_AddChampionProvider,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.AddChampionProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.AddChampionProviderResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.addChampionProvider =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/AddChampionProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_AddChampionProvider);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ReopenJobRequest,
 *   !proto.worklayer.internal.v1.ReopenJobResponse>}
 */
const methodDescriptor_JobAdminService_ReopenJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/ReopenJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ReopenJobRequest,
  proto.worklayer.internal.v1.ReopenJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ReopenJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ReopenJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ReopenJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ReopenJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ReopenJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.reopenJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ReopenJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ReopenJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ReopenJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ReopenJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.reopenJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ReopenJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ReopenJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CreateAmendmentRequest,
 *   !proto.worklayer.internal.v1.CreateAmendmentResponse>}
 */
const methodDescriptor_JobAdminService_CreateAmendment = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/CreateAmendment',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CreateAmendmentRequest,
  proto.worklayer.internal.v1.CreateAmendmentResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CreateAmendmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CreateAmendmentResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CreateAmendmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CreateAmendmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CreateAmendmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.createAmendment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/CreateAmendment',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_CreateAmendment,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CreateAmendmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CreateAmendmentResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.createAmendment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/CreateAmendment',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_CreateAmendment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CompleteJobRequest,
 *   !proto.worklayer.internal.v1.CompleteJobResponse>}
 */
const methodDescriptor_JobAdminService_CompleteJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/CompleteJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CompleteJobRequest,
  proto.worklayer.internal.v1.CompleteJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CompleteJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CompleteJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CompleteJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CompleteJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CompleteJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.completeJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/CompleteJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_CompleteJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CompleteJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CompleteJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.completeJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/CompleteJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_CompleteJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CancelJobRequest,
 *   !proto.worklayer.internal.v1.CancelJobResponse>}
 */
const methodDescriptor_JobAdminService_CancelJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/CancelJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CancelJobRequest,
  proto.worklayer.internal.v1.CancelJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CancelJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CancelJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CancelJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CancelJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CancelJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.cancelJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/CancelJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_CancelJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CancelJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CancelJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.cancelJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/CancelJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_CancelJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ArchiveJobRequest,
 *   !proto.worklayer.internal.v1.ArchiveJobResponse>}
 */
const methodDescriptor_JobAdminService_ArchiveJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/ArchiveJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ArchiveJobRequest,
  proto.worklayer.internal.v1.ArchiveJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ArchiveJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ArchiveJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ArchiveJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ArchiveJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ArchiveJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.archiveJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ArchiveJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ArchiveJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ArchiveJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ArchiveJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.archiveJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ArchiveJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ArchiveJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CloseJobAsTestRequest,
 *   !proto.worklayer.internal.v1.CloseJobAsTestResponse>}
 */
const methodDescriptor_JobAdminService_CloseJobAsTest = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/CloseJobAsTest',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CloseJobAsTestRequest,
  proto.worklayer.internal.v1.CloseJobAsTestResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CloseJobAsTestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CloseJobAsTestResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CloseJobAsTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CloseJobAsTestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CloseJobAsTestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.closeJobAsTest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/CloseJobAsTest',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_CloseJobAsTest,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CloseJobAsTestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CloseJobAsTestResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.closeJobAsTest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/CloseJobAsTest',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_CloseJobAsTest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ManuallySplitJobPayoutRequest,
 *   !proto.worklayer.internal.v1.ManuallySplitJobPayoutResponse>}
 */
const methodDescriptor_JobAdminService_ManuallySplitJobPayout = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/ManuallySplitJobPayout',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ManuallySplitJobPayoutRequest,
  proto.worklayer.internal.v1.ManuallySplitJobPayoutResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ManuallySplitJobPayoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ManuallySplitJobPayoutResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ManuallySplitJobPayoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ManuallySplitJobPayoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ManuallySplitJobPayoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.manuallySplitJobPayout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ManuallySplitJobPayout',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ManuallySplitJobPayout,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ManuallySplitJobPayoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ManuallySplitJobPayoutResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.manuallySplitJobPayout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ManuallySplitJobPayout',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ManuallySplitJobPayout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.OverrideDeadlineRequest,
 *   !proto.worklayer.internal.v1.OverrideDeadlineResponse>}
 */
const methodDescriptor_JobAdminService_OverrideDeadline = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/OverrideDeadline',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.OverrideDeadlineRequest,
  proto.worklayer.internal.v1.OverrideDeadlineResponse,
  /**
   * @param {!proto.worklayer.internal.v1.OverrideDeadlineRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.OverrideDeadlineResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.OverrideDeadlineRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.OverrideDeadlineResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.OverrideDeadlineResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.overrideDeadline =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/OverrideDeadline',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_OverrideDeadline,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.OverrideDeadlineRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.OverrideDeadlineResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.overrideDeadline =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/OverrideDeadline',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_OverrideDeadline);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ListJobQuestionVariablesRequest,
 *   !proto.worklayer.internal.v1.ListJobQuestionVariablesResponse>}
 */
const methodDescriptor_JobAdminService_ListJobQuestionVariables = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/ListJobQuestionVariables',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ListJobQuestionVariablesRequest,
  proto.worklayer.internal.v1.ListJobQuestionVariablesResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ListJobQuestionVariablesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ListJobQuestionVariablesResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ListJobQuestionVariablesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ListJobQuestionVariablesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ListJobQuestionVariablesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.listJobQuestionVariables =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ListJobQuestionVariables',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ListJobQuestionVariables,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ListJobQuestionVariablesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ListJobQuestionVariablesResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.listJobQuestionVariables =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ListJobQuestionVariables',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ListJobQuestionVariables);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.AddInvoiceRequest,
 *   !proto.worklayer.internal.v1.AddInvoiceResponse>}
 */
const methodDescriptor_JobAdminService_AddInvoice = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/AddInvoice',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.AddInvoiceRequest,
  proto.worklayer.internal.v1.AddInvoiceResponse,
  /**
   * @param {!proto.worklayer.internal.v1.AddInvoiceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.AddInvoiceResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.AddInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.AddInvoiceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.AddInvoiceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.addInvoice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/AddInvoice',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_AddInvoice,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.AddInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.AddInvoiceResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.addInvoice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/AddInvoice',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_AddInvoice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ApplyCouponToJobRequest,
 *   !proto.worklayer.internal.v1.ApplyCouponToJobResponse>}
 */
const methodDescriptor_JobAdminService_ApplyCoupon = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/ApplyCoupon',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ApplyCouponToJobRequest,
  proto.worklayer.internal.v1.ApplyCouponToJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ApplyCouponToJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ApplyCouponToJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ApplyCouponToJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ApplyCouponToJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ApplyCouponToJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.applyCoupon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ApplyCoupon',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ApplyCoupon,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ApplyCouponToJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ApplyCouponToJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.applyCoupon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ApplyCoupon',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ApplyCoupon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RemoveCouponFromJobRequest,
 *   !proto.worklayer.internal.v1.RemoveCouponFromJobResponse>}
 */
const methodDescriptor_JobAdminService_RemoveCoupon = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/RemoveCoupon',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RemoveCouponFromJobRequest,
  proto.worklayer.internal.v1.RemoveCouponFromJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RemoveCouponFromJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RemoveCouponFromJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RemoveCouponFromJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RemoveCouponFromJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RemoveCouponFromJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.removeCoupon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RemoveCoupon',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RemoveCoupon,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RemoveCouponFromJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RemoveCouponFromJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.removeCoupon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RemoveCoupon',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RemoveCoupon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ChargeRequest,
 *   !proto.worklayer.internal.v1.ChargeResponse>}
 */
const methodDescriptor_JobAdminService_ChargeJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/ChargeJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ChargeRequest,
  proto.worklayer.internal.v1.ChargeResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ChargeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ChargeResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ChargeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ChargeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ChargeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.chargeJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ChargeJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ChargeJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ChargeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ChargeResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.chargeJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/ChargeJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_ChargeJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RefundRequest,
 *   !proto.worklayer.internal.v1.RefundResponse>}
 */
const methodDescriptor_JobAdminService_RefundJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/RefundJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RefundRequest,
  proto.worklayer.internal.v1.RefundResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RefundRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RefundResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RefundRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RefundResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RefundResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.refundJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RefundJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RefundJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RefundRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RefundResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.refundJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RefundJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RefundJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.NotifyProvidersOfOpenJobRequest,
 *   !proto.worklayer.internal.v1.NotifyProvidersOfOpenJobResponse>}
 */
const methodDescriptor_JobAdminService_NotifyProvidersOfOpenJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/NotifyProvidersOfOpenJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.NotifyProvidersOfOpenJobRequest,
  proto.worklayer.internal.v1.NotifyProvidersOfOpenJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.NotifyProvidersOfOpenJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.NotifyProvidersOfOpenJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.NotifyProvidersOfOpenJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.NotifyProvidersOfOpenJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.NotifyProvidersOfOpenJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.notifyProvidersOfOpenJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/NotifyProvidersOfOpenJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_NotifyProvidersOfOpenJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.NotifyProvidersOfOpenJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.NotifyProvidersOfOpenJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.notifyProvidersOfOpenJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/NotifyProvidersOfOpenJob',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_NotifyProvidersOfOpenJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.BulkArchiveJobsRequest,
 *   !proto.worklayer.internal.v1.BulkArchiveJobsResponse>}
 */
const methodDescriptor_JobAdminService_BulkArchive = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/BulkArchive',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.BulkArchiveJobsRequest,
  proto.worklayer.internal.v1.BulkArchiveJobsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.BulkArchiveJobsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.BulkArchiveJobsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.BulkArchiveJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.BulkArchiveJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.BulkArchiveJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.bulkArchive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkArchive',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkArchive,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.BulkArchiveJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.BulkArchiveJobsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.bulkArchive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkArchive',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkArchive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.BulkRestoreJobsRequest,
 *   !proto.worklayer.internal.v1.BulkRestoreJobsResponse>}
 */
const methodDescriptor_JobAdminService_BulkRestore = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/BulkRestore',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.BulkRestoreJobsRequest,
  proto.worklayer.internal.v1.BulkRestoreJobsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.BulkRestoreJobsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.BulkRestoreJobsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.BulkRestoreJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.BulkRestoreJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.BulkRestoreJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.bulkRestore =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkRestore',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkRestore,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.BulkRestoreJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.BulkRestoreJobsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.bulkRestore =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkRestore',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkRestore);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RequestJobChampionProviderRequest,
 *   !proto.worklayer.internal.v1.RequestJobChampionProviderResponse>}
 */
const methodDescriptor_JobAdminService_RequestChampionProvider = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/RequestChampionProvider',
  grpc.web.MethodType.UNARY,
  internal_job_pb.RequestJobChampionProviderRequest,
  internal_job_pb.RequestJobChampionProviderResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  internal_job_pb.RequestJobChampionProviderResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RequestJobChampionProviderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RequestJobChampionProviderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.requestChampionProvider =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RequestChampionProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RequestChampionProvider,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RequestJobChampionProviderResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.requestChampionProvider =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/RequestChampionProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_RequestChampionProvider);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.BulkTransferJobsToPoolRequest,
 *   !proto.worklayer.internal.v1.BulkTransferJobsResponse>}
 */
const methodDescriptor_JobAdminService_BulkTransferJobsToPool = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToPool',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.BulkTransferJobsToPoolRequest,
  proto.worklayer.internal.v1.BulkTransferJobsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.BulkTransferJobsToPoolRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.BulkTransferJobsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.BulkTransferJobsToPoolRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.BulkTransferJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.BulkTransferJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.bulkTransferJobsToPool =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToPool',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkTransferJobsToPool,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.BulkTransferJobsToPoolRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.BulkTransferJobsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.bulkTransferJobsToPool =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToPool',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkTransferJobsToPool);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.BulkTransferJobsToClientTeamRequest,
 *   !proto.worklayer.internal.v1.BulkTransferJobsResponse>}
 */
const methodDescriptor_JobAdminService_BulkTransferJobsToClientTeam = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToClientTeam',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.BulkTransferJobsToClientTeamRequest,
  proto.worklayer.internal.v1.BulkTransferJobsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.BulkTransferJobsToClientTeamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.BulkTransferJobsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.BulkTransferJobsToClientTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.BulkTransferJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.BulkTransferJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.bulkTransferJobsToClientTeam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToClientTeam',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkTransferJobsToClientTeam,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.BulkTransferJobsToClientTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.BulkTransferJobsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.bulkTransferJobsToClientTeam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToClientTeam',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkTransferJobsToClientTeam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.BulkTransferJobsToClientRequest,
 *   !proto.worklayer.internal.v1.BulkTransferJobsResponse>}
 */
const methodDescriptor_JobAdminService_BulkTransferJobsToClient = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToClient',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.BulkTransferJobsToClientRequest,
  proto.worklayer.internal.v1.BulkTransferJobsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.BulkTransferJobsToClientRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.BulkTransferJobsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.BulkTransferJobsToClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.BulkTransferJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.BulkTransferJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.bulkTransferJobsToClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToClient',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkTransferJobsToClient,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.BulkTransferJobsToClientRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.BulkTransferJobsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.bulkTransferJobsToClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToClient',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkTransferJobsToClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.BulkTransferJobsToProviderRequest,
 *   !proto.worklayer.internal.v1.BulkTransferJobsResponse>}
 */
const methodDescriptor_JobAdminService_BulkTransferJobsToProvider = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToProvider',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.BulkTransferJobsToProviderRequest,
  proto.worklayer.internal.v1.BulkTransferJobsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.BulkTransferJobsToProviderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.BulkTransferJobsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.BulkTransferJobsToProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.BulkTransferJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.BulkTransferJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobAdminServiceClient.prototype.bulkTransferJobsToProvider =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkTransferJobsToProvider,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.BulkTransferJobsToProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.BulkTransferJobsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobAdminServicePromiseClient.prototype.bulkTransferJobsToProvider =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobAdminService/BulkTransferJobsToProvider',
      request,
      metadata || {},
      methodDescriptor_JobAdminService_BulkTransferJobsToProvider);
};


module.exports = proto.worklayer.internal.v1;

